<style lang="scss" scoped>

.fade-enter-active,
.fade-leave-active {
    transition: all 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
    transform: translateY(-20%);
    opacity: 0;
}

.row_action {
  cursor: pointer;
  &:hover {
    background-color: #F8FAFC;
  }
}

.row_action {
  cursor: pointer;
  &:hover {
    background-color: #EFF5FB;
  }
}

.is-incomplete, .is-incomplete .text-muted {
    //color: #FFFFFF ! important;
    //background-color: #D3E4F9;
}

.bold-text {
    font-weight: 800;
}

</style>

<template>
    
    <div v-if="profile.waterPointId" class="row mt-1 mb-1"> 
        <div class="col-12">
            <WaterPointSelect ref="waterPointSelect" :waterPointId="profile.waterPointId" :disabled="true" :updateOnChange="irrigationList"></WaterPointSelect>
       </div>
    </div>
    
    <WaterPointWellAlert :waterPointId="profile.waterPointId"></WaterPointWellAlert>
    
    <div class="row align-items-center p-2">
        <div class="col">
            <!-- Page pre-title -->
            <div class="page-pretitle">
                Erfassen & Speichern
            </div>
            <h2 class="page-title">
                Entnahmen
            </h2>
        </div>
        <!-- Page title actions -->
        <div v-show="isAllCompleted && !this.loading" class="col-auto ms-auto d-print-none">
            <div class="btn-list">
                <a href="#" class="btn btn-info d-none d-sm-inline-block" @click="openAlterModal()">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                Maßnahme dokumentieren
                </a>
                <a href="#" class="btn btn-info d-sm-none btn-icon" @click="openAlterModal()" aria-label="Create new report">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                </a>
            </div>
        </div>
    </div>
           
    <Alert type="info" :show="alertEmpty">
        <template v-slot:title>Keine Entnahme dokumentiert</template>
        Zur Dokumentation einer neuen Entnahme zu Bewässerung klicken Sie bitte auf das blau hinterlegte PLUS
    </Alert>
    
    <Alert type="info" :show="alertNew" :timeout="30000">
        <template v-slot:title>Entnahme dokumentiert</template>
        Alle Informationen zur Entnahme und weitere Optionen (Fortführung oder Korrektur) erhalten Sie durch einen Klick auf die ensprechende Zeile der Liste.
    </Alert>
    
    <Alert type="success" :show="alertRemove" :timeout="6000">
        <template v-slot:title>Entnahme korrigiert</template>
        Die Korrektur der Entnahme wurde gespeichert. Vorherige Stände bleiben erhalten. 
    </Alert>
 
    <div v-show="loading || loadingSensorSelect" class="progress progress-sm mb-2">
        <div class="progress-bar progress-bar-indeterminate bg-blue"></div>
    </div>
    
    <div class="row mt-1 mb-2">
        <div class="col-12">
            <SensorSelect @click="checkMissingData" :select="showSensorList" :profile="profile" :parameterId="'e'" :confirmRemoveFromProfile="ConfirmRemoveFromProfile" @addSensorToProfile="onSensorChanged" @removeSensorFromProfile="onSensorChanged" v-model:loading="loadingSensorSelect">
                <template v-slot:alertAddSensorToProfile>
                    {{ state.profile.item().area }} {{ state.profile.item().waterPointId }}
                    <Alert type="alert" :show="true">
                        <template v-slot:title>Keine Entnahme dokumentiert</template>
                        Zur Dokumentation einer neuen Entnahme zu Bewässerung klicken Sie bitte auf das blau hinterlegte PLUS
                    </Alert>
                </template>
            </SensorSelect>
        </div>
    </div>
    
    <div v-show="irrigationList.length > 0" class="card_">
        <div class="table-responsive mt-2">
            <table class="table table-vcenter card-table">
                <thead>
                    <tr>
                        <th title="Beginn der Maßnahme">
                            Termin, Start
                        </th>
                        <th title="Wasserzählerstand zu Beginn der Maßnahme in m³">
                            Zähler, Start
                        </th>
                        <th title="Wasserentnahme in m³">
                            Entnahme
                        </th>
                        <th title="Wassergabe in mm">
                            Quelle
                        </th>
                        <th title="Wassergabe in mm">
                            Gabe
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="irrigation in reverseList(irrigationList)" v-bind:key="irrigation.id" :class="{'is-incomplete':!isIrrigationCompleted(irrigation) }"
                        class="row_action" data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-original-title="Enable dark mode" @click="openAlterModal(irrigation)">
                        <td title="Beginn der Maßnahme">
                            <small class="d-block text-muted text-truncate">
                                {{ formatDateTime(irrigation.datetime, 'DD.MM') }}, {{ formatDateTime(irrigation.datetime, 'HH:mm') }}                            
                            </small>
                        </td>
                        <td v-if="!isIrrigationCompleted(irrigation)" colspan="4" title="Bitte schließen Sie die Entnahme ab">
                            <small class="d-block text-muted text-truncate">
                                <span class="text-start me-auto">Dokumentierten Zählerstand zum Start anzeigen</span>  
                                <span class="bold-text ms-auto float-end"> Begonnene Entnahme jetzt abschließen</span>
                            </small>
                        </td>
                        <td v-if="isIrrigationCompleted(irrigation)" title="Fäche des Schlags in m²" >
                            <small class="d-block text-muted text-truncate">
                                <span v-if="getCountStart(irrigation) !== null">
                                    {{ Math.round(getCountStart(irrigation)).toLocaleString() }} m³
                                </span>
                            </small>
                        </td>
                        <td v-if="isIrrigationCompleted(irrigation)" title="Wasserentnahme in m³">
                            <small class="d-block text-muted text-truncate">
                                <span v-if="getWaterWithdrawal(irrigation) === null">
                                </span>
                                <span v-else-if="Math.round(getWaterWithdrawal(irrigation)) > 0 ">
                                    {{ Math.round(getWaterWithdrawal(irrigation)).toLocaleString() }} m³
                                </span>
                                <span v-else class="opacity-50">
                                    {{ getWaterWithdrawal(irrigation).toLocaleString(undefined, {minimumFractionDigits: 3, maximumFractionDigits: 3}) }}  m³
                                </span>
                            </small> 
                        </td>
                        <td v-if="isIrrigationCompleted(irrigation)" title="Datenquelle der Entnahme">
                            <span v-if="irrigation.typ == 'sensor'">
                                <svg xmlns="http://www.w3.org/2000/svg" class="icon text-muted" width="24" height="24" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                    <path d="M20 11a8.1 8.1 0 0 0 -6.986 -6.918a8.095 8.095 0 0 0 -8.019 3.918" />
                                    <path d="M4 13a8.1 8.1 0 0 0 15 3" />
                                    <path d="M19 16m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
                                    <path d="M5 8m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
                                    <path d="M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
                                </svg>                        
                                <small class="text-muted text-truncate ms-0">
                                    Sensor
                                </small>
                            </span>
                            <span v-else-if="irrigation.typ == 'manually' || true">
                                <svg xmlns="http://www.w3.org/2000/svg" class="icon text-muted" width="24" height="24" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round" transform="matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0,0)">
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                    <path d="M20.779 10.007a9 9 0 1 0 -10.77 10.772" />
                                    <path d="M13 21h8v-7" /><path d="M12 8v4l3 3" />
                                </svg>                        
                                <small class="text-muted text-truncate ms-0">
                                    Manuell
                                </small>
                            </span>
                        </td>
                        <td v-if="isIrrigationCompleted(irrigation)" title="Wassergabe in mm" >
                            <small class="d-block text-muted text-truncate">
                                <span v-if="getIrrigationLevel(irrigation) === null">
                                </span>
                                <span v-else>
                                    {{  getIrrigationLevel(irrigation).toLocaleString(undefined, {minimumFractionDigits: 0, maximumFractionDigits: 1}) }} mm
                                </span>
                            </small> 
                            <div v-if="getIrrigationLevel(irrigation)" class="progress progress-sm">
                                <div class="progress-bar bg-primary" :style="{width: '{}%'.format(Math.ceil(getIrrigationLevel(irrigation))*4)}">
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <AlterModal ref="alterIrrigation" v-model:mode="alterMode" :profile="profile" :irrigation="irrigation" :irrigationList="irrigationList" v-on:submit="submitAlterModal" :key="modalKey">
    </AlterModal>
    
    <MissingDataModal ref="missingDataModal" :profile="profile" @submit="submitMissingDataModal" :key="modalKey">
    </MissingDataModal>
    
</template>

<script>
import * as dayjs from 'dayjs';
import axios from 'axios'; 

import { markRaw } from 'vue';

import SensorSelect from '@/components/sensor/SensorSelect.vue';
import AlterModal from '@/components/irrigation/AlterModal.vue';
import MissingDataModal from '@/components/irrigation/MissingDataModal.vue';
import ConfirmRemoveFromProfile from '@/components/irrigation/ConfirmRemoveFromProfile.vue';
import Alert from '@/components/Alert.vue';
import WaterPointSelect from '@/components/waterpoint/WaterPointSelect.vue';
import WaterPointWellAlert from '@/components/waterpoint/WaterPointWellAlert.vue';

import { common } from "@/global";

export default {
    name: 'Precipitation',
    components: {
        SensorSelect,
        AlterModal,
        MissingDataModal,
        Alert,
        WaterPointSelect,
        WaterPointWellAlert
    },
    inject: [
        'state',
        'config'
    ],
    props: {
        profile: {
            type: Object,
            default: undefined
        }
    },
    data: function() {
        return {
            irrigationList : [],
            irrigation: null,
            alterMode: 'new',
            loading: false,
            loadingSensorSelect: false,
            loadingProgress: null,
            alertNew: false,
            alertEmpty: false,
            alertRemove: false,
            modalKey: 0,
            sensorSelectCallback: null,
            showSensorList: false
        }
    },
    computed: {
        profileArea: function () {
            return this.state.profile.item().area;               
        },
        isAllCompleted: function () {
            return this.irrigationList.filter (function (item) {
                return (item.countEnd === null);
            }).length === 0;
        },
        ConfirmRemoveFromProfile:  function () {
            return markRaw(ConfirmRemoveFromProfile);
        }
    },
    methods: {
        openAlterModal: function (irrigation=null) { 
            this.alterMode = irrigation ? 'view': 'new';
             
            if (irrigation && !this.isIrrigationCompleted(irrigation)) {
                this.alterMode = 'complete';    
            }

            this.modalKey = this.modalKey + 1;
            this.irrigation = irrigation ? irrigation: {};
           
            this.$nextTick(function() { 
                this.$refs.alterIrrigation.openModal();
            });
        },
        submitAlterModal: function (irrigation) {
            let self = this;
            
             // Set new waterPointId for profile
            self.state.actions.profile.set({waterPointId: irrigation.waterpointId})
            
            self.alertNew = false;
            if (irrigation.area) {
                self.alterProfile(irrigation.profileId, irrigation.area, null, function () {
                    self.addData(irrigation, function () {
                        self.alertNew = true;
                    });                        
                });
            } else {
                self.addData(irrigation, function () {
                    self.alertNew = true;
                });
            }
        },
        submitRemoveModal: function (correction) {
            let self = this;
            
            self.alertRemove = false;
            self.removeData(correction, function () {
                self.alertRemove = true;
            });
        },
        openMissingDataModal: function () { 
            this.modalKey = this.modalKey + 1;
            this.$nextTick(function() { 
                this.$refs.missingDataModal.openModal();
            });
        },
        submitMissingDataModal: function (waterPointId, area) {
            const self = this;
            self.alterProfile(this.profile.id, area, waterPointId, function () {
                    self.showSensorList = true;        
            });
        },
        checkMissingData: function() {
        
            if (!this.profile.area || !this.profile.waterPointId) {
                this.openMissingDataModal();
                return;
            }
        
            this.showSensorList = false;
            this.$nextTick(function() { 
                this.showSensorList = true;
            });
        
        },
        reverseList: function (list) {
            return [].concat(list).reverse();
        },
        isIrrigationCompleted: function (irrigation) {
            return !(irrigation.countEnd === null);
        },
        formatDateTime: function (date, format) {
            return dayjs(date).format(format);
        },
        getCountStart: function (irrigation) {
            return irrigation.countStart;
        },
        getWaterWithdrawal: function (irrigation) {
            if (irrigation.countStart !== null && irrigation.countEnd !== null) {
                if (irrigation.countStart < irrigation.countEnd) {
                    return (irrigation.countEnd - irrigation.countStart);
                }
            }
            return null;
        },
        getIrrigationLevel: function (irrigation) {
            if (this.getWaterWithdrawal(irrigation) && this.profileArea) {
                return (1000 * this.getWaterWithdrawal(irrigation)) / this.profileArea
            }
            return null;
        },
        meterToHectare: function (area) {
            return common.meterToHectare(area)
        },
        getImage: function (irrigation) {    
            let images = irrigation.images
        
            if (!images) {
                images = []
            }
            
            if (images.length < 1) {
                return null;
            }
        
            return '{}/{}'.format(
                this.config.images.download,
                images[0].asset_id
            );
        },
        updateWeatherData: function (weatherData) {
            if (weatherData.weatherData) {
                this.weatherData = this.parseJSONList(weatherData.weatherData);
            }
            
            if (weatherData.chainedWeatherData) {
                this.weatherDataCorrected = this.parseJSONList(weatherData.chainedWeatherData);
            }
        },
        onSensorChanged: function(sensor) {
            this.fetchData();
        },
        fetchData: function (callback) {
            let self = this;
            
            let query = {
                query: `
                    query (
                        $profileId: Int! 
                        $year: Int!
                    ) {
                        irrigationActions(profileId: $profileId, year: $year) {
                            id
                            profileId
                            waterpointId
                            refId
                            typ
                            datetime
                            extractionRate
                            countStart
                            countEnd
                            stillWaterLevel
                            normalWaterLevel
                            images
                            comment
                            transferIrrigationLevel
                        },
                        loggedIn
                    }
                `,      
                variables: {
                    profileId : self.profile.id,
                    year: self.profile.year,
                }           
            }
            
            let request = Object.assign({}, self.config.request,
            {
                data: query,
            });
           
            self.loading = true;
            
            axios(request).then( function (response) {
                let data = response.data.data;
            
                if ( data !== null ) {
                    self.irrigationList = data.irrigationActions.map( function (item) {
                        item.images = JSON.parse(item.images);
                        return item;
                    });
                    
                } else {
                    console.log(data);    
                }
            
            }).catch(function (error) {
                console.log(error);
            }).then(function () {
                self.loading = false;
                
                if (callback) {
                    callback(self);
                }
                
            });
        },
        addData: function (irrigation, callback) {
            let self = this;
            
            const query = {
                query: `
                  mutation (
                    $profileId: Int!
                    $year: Int!
                    $waterpointId: Int!
                    $id: Int
                    $refId: Int
                    $datetime: DateTime
                    $extractionRate: Float
                    $countStart: Float
                    $countEnd: Float
                    $stillWaterLevel: Float  
                    $normalWaterLevel: Float
                    $comment: String
                    $transferIrrigationLevel: Boolean
                    $images: JSONString
                    $file: Upload!
                    ) {
                        alterIrrigationAction(
                            profileId: $profileId
                            year: $year
                            waterpointId: $waterpointId
                            id: $id
                            refId: $refId
                            datetime: $datetime
                            extractionRate: $extractionRate
                            countStart: $countStart
                            countEnd: $countEnd
                            stillWaterLevel: $stillWaterLevel
                            normalWaterLevel: $normalWaterLevel
                            comment: $comment
                            transferIrrigationLevel: $transferIrrigationLevel
                            images: $images
                            file: $file ) {
                                success,
                                irrigationList {
                                    id
                                    profileId
                                    waterpointId
                                    refId
                                    typ
                                    datetime
                                    extractionRate
                                    countStart
                                    countEnd
                                    stillWaterLevel
                                    normalWaterLevel
                                    comment
                                    transferIrrigationLevel
                                    images
                                }
                            }
                    }`
                ,
                variables: {
                    profileId: irrigation.profileId,
                    year: self.profile.year,
                    waterpointId: irrigation.waterpointId,
                    id: irrigation.id,
                    refId: irrigation.refId,
                    datetime: irrigation.datetime,
                    extractionRate: irrigation.extractionRate,
                    countStart: irrigation.countStart,
                    countEnd: irrigation.countEnd,
                    stillWaterLevel: irrigation.stillWaterLevel,
                    normalWaterLevel: irrigation.normalWaterLevel,
                    comment: irrigation.comment,
                    transferIrrigationLevel: irrigation.transferIrrigationLevel,
                    images: irrigation.images        
                }
            };
            
            const formData = new FormData();
           
            if (irrigation.images.length > 0) {
                const map = {
                    "0": ["variables.file"]
                };
                
                const {file, datetime, position} = irrigation.images[0];
                query.variables.images = JSON.stringify([{datetime, position}]);
                query.variables.file = null;

                formData.append("operations", JSON.stringify(query));
                formData.append("map", JSON.stringify(map));
                formData.append("0", file);
            } else {
                query.variables.images = JSON.stringify([]);
                query.variables.file = "";
                formData.append("operations", JSON.stringify(query)); 
            }
            
            let request = Object.assign({}, self.config.request,
            {
                data: formData,
                headers: {
                    "Content-Type": "multipart/form-data"
                },
                onUploadProgress: function (progressEvent) {
                    self.loadingProgress = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total));
                }
            
            });
                        
            self.loading = true;
            self.loadingProgress = null;

            axios(request).then( function (response) {
                let data = response.data.data;
                
                if ( data !== null ) {
                    self.irrigationList = data.alterIrrigationAction.irrigationList.map( function (item) {
                        item.images = JSON.parse(item.images);
                        return item;
                    });

                } else {
                    console.log(data);    
                }
            
            }).catch(function (error) {
                console.log(error);
            }).then(function () {
                self.loading = false;
                
                if (callback) {
                    callback(self);
                }
                
            });
            
        },
        alterProfile: function (profileId, area, waterPointId, callback) {
            let self = this;
                       
            let query = {
                query: `
                    mutation (
                        $profileId: Int!
                        $area: Int
                        $waterpointId: Int
                    ) {
                       alterProfile (
                        profileId: $profileId
                        area: $area
                        waterpointId: $waterpointId                      
                             ) {
                            profile {
                                id
                                area
                                waterPointId
                            }
                          }
                        }
                `,      
                variables: {                    
                    profileId: profileId,
                    area: area,
                    waterpointId: waterPointId
                }           
            }
            
            let request = Object.assign({}, self.config.request);
            request["data"] = query;
            
            self.loading = true;
            
            axios(request).then( function (response) {
                let data = response.data.data;
                
                if ( data !== null ) {
                    self.state.actions.profile.set(
                        {
                            area: data.alterProfile.profile.area,
                            waterPointId: data.alterProfile.profile.waterPointId
                        }, 
                        data.alterProfile.profile.id
                    );
                } else {
                    console.log(data);    
                }
            
            }).catch(function (error) {
                console.log(error);
            }).then(function () {
                self.loading = false;
                
                if (callback) {
                    callback(self);
                }
            });
        }
    },
    created: function () {
        
    },
    mounted: function () {
        var self = this;
        
        self.$nextTick(function() { 
             self.fetchData( function () {}); 
        });
        
    },
    watch: {    
        loading: function (new_value, old_value) {
            // LOADING STARTING
            if ( new_value === true && old_value === false ) {
                this.alertEmpty = false;
            }
    
            // LOADING FINISHED
            if ( new_value === false && old_value === true ) {
                if (this.irrigationList.length == 0) {
                    this.alertEmpty = true;
                } else {
                    this.alertEmpty = false;
                }      
            }
        },
        isAllCompleted: function (new_value, old_value) { 
            if ( new_value === true && old_value === false ) {
                this.state.actions.profile.set({allIrrigationsCompleted: true});
            } else if ( new_value === false && old_value === true ) {
                this.state.actions.profile.set({allIrrigationsCompleted: false});
            }
        },
        irrigationList: function () { 
            var self = this;
            self.$nextTick(function() { 
                self.state.actions.withdrawal.setList(self.irrigationList);
            });
        },
        '$route.query': {
            handler (new_value) {
                let action = new_value.action; 
                
                if (action && action === 'newwithdrawal' ) {
                    this.openAlterModal();
                    this.$router.replace(this.$route.path);
                }
                
                if (action && action === 'missingdatamodal' ) {
                    this.$nextTick(function() { 
                        this.$refs.missingDataModal.openModal();
                    });
                    this.$router.replace(this.$route.path);
                }
            },
            immediate: true           
        }        
    }
}
</script>